import AppSections from "./AppSections";
import Audience from "./Audience";
import AppIcons from "./AppIcons";
import AppSubSections from "./AppSubSections";

const leftMenuItems = [
  {
    label: "Dashboard",
    identifier: AppSections.DASHBOARD,
    icon: AppIcons.DASHBOARD,
    audience: Audience.AUTHENTICATED,
  },
  {
    label: "Search",
    identifier: AppSections.SEARCH,
    icon: AppIcons.SEARCH,
    audience: Audience.AUTHENTICATED,
  },
  {
    label: "admin_separator",
    audience: Audience.AUTHENTICATED,
  },
  {
    label: "Users",
    identifier: AppSections.USERS,
    icon: AppIcons.USER,
    audience: Audience.AUTHENTICATED,
  },
  {
    label: "Alteration Forms",
    identifier: AppSections.ALTERATION_FORMS,
    icon: AppIcons.ALTERATION_FORMS,
    audience: Audience.AUTHENTICATED,
  },
  {
    label: "Materials",
    identifier: AppSections.MATERIALS,
    icon: AppIcons.MATERIALS,
    audience: Audience.AUTHENTICATED,
  },
  {
    label: "Static Content",
    identifier: AppSections.STATIC_PAGES,
    icon: AppIcons.DOCUMENTS,
    audience: Audience.AUTHENTICATED,
  },
];

const topMenuItems = [
  {
    label: "Explore records",
    identifier: AppSections.CHELEMENTS,
    icon: AppIcons.CH_ELEMENT,
    audience: Audience.AUTHENTICATED,
  },
  {
    label: "View Collections",
    identifier: AppSections.COLLECTIONS,
    icon: AppIcons.SITE,
    audience: Audience.AUTHENTICATED,
  },
  {
    label: "Visit Sites",
    identifier: AppSections.SITES,
    icon: AppIcons.SITE,
    audience: Audience.AUTHENTICATED,
  },
  {
    label: "Learn about ChemiNova Case Studies",
    identifier: AppSections.PILOTS,
    icon: AppIcons.PILOT,
    audience: Audience.ANONYMOUS,
  },
  {
    label: "Add a Record",
    identifier: AppSections.CHELEMENTS,
    action: AppSubSections.CREATE,
    icon: AppIcons.CH_ELEMENT,
    audience: Audience.AUTHENTICATED,
  },
];

export { leftMenuItems, topMenuItems };
